import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";
import AddImage from "../Components/AddImage";
import InputContent from "../Components/InputContent";
import InputTitle from "../Components/InputTitle";
import RadioOption from "../Components/RadioOption";
import ImageExBanner from "../Images/imageEx_banner.jpg";
import ImageExDetail from "../Images/imageEx_notice_banner_detail.jpg";
import ScreenExBanner from "../Images/screenEx_banner.jpg";
import ScreenExDetail from "../Images/screenEx_banner_detail.jpg";
import Layout from "../Layout/Layout";
import AlarmApply from "../Modals/AlarmApply";
import AlarmCancel from "../Modals/AlarmCancel";
import AlarmInputCheck from "../Modals/AlarmInputCheck";
import ImageEx from "../Modals/ImageEx";
import ImageUpload from "../Modals/ImageUpload";
import "../Styles/component.css";
import "../Styles/global.css";
import { postFormData, postJson } from "../Utils/apiUtils";

const BannerApplyContent = () => {
  const { id } = useParams();
  const isEditing = !!id;
  const navigate = useNavigate();

  const [mainImage, setMainImage] = useState(null);
  const [subImage, setSubImage] = useState(null);
  const [nation, setNation] = useState(0);
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");

  const [clickImageEx_banner, setClickImageEx_banner] = useState(false);
  const [clickImageEx_detail, setClickImageEx_detail] = useState(false);

  const [clickUpload_banner, setClickUpload_banner] = useState(false);
  const [clickUpload_detail, setClickUpload_detail] = useState(false);

  const [clickApply, setClickApply] = useState(false);
  const [clickCancel, setClickCancel] = useState(false);

  const [inputCheckFail, setInputCheckFail] = useState(false);
  const lastBannerDetailRequestKey = useRef(null);

  const applyButtonOK = mainImage && nation !== null && subImage && title;

  const handleClickX = () => {
    setClickImageEx_banner(false);
    setClickImageEx_detail(false);
    setClickUpload_banner(false);
    setClickUpload_detail(false);
    setClickApply(false);
    setClickCancel(false);
    setInputCheckFail(false);
  };

  const handleApplyBanner = async () => {
    if (!applyButtonOK) {
      setInputCheckFail(true);
    } else {
      try {
        const cCode = nation === 0 ? "kr" : nation === 1 ? "99" : "";

        const formData = new FormData();
        formData.append("cCode", cCode);
        formData.append("title", title);
        formData.append("content", content);
        formData.append("mainImage", mainImage[0]);
        formData.append("subImage", subImage[0]);

        let data;

        if (isEditing) {
          formData.append("bannerId", id);
          data = await postFormData("/dashboard/banner/update", formData, navigate);
        } else {
          data = await postFormData("/dashboard/banner/create", formData, navigate);
        }
        if (data.code === 200) {
          navigate("/banner", { state: { toast_enable: true } });
        }
      } catch (error) {
        console.log("배너 등록/수정 중 에러:", error);
        throw error;
      }
    }
  };

  const getBannerData = async () => {
    try {
      const body = { bannerId: id };
      const res = await postJson("/dashboard/banner/getDetail", body, navigate);

      if (res.code === 200) {
        const data = res.data;
        setNation(data.cCode === "kr" ? 0 : 1);
        setTitle(data.title);
        setContent(data.content);
        setMainImage(data.mainImage);
        setSubImage(data.subImage);
      }
    } catch (error) {
      console.log("배너 데이터 가져오기 중 에러:", error);
      throw error;
    }
  };

  useEffect(() => {
    if (!isEditing) {
      return;
    }

    const requestKey = JSON.stringify({ id });

    if (lastBannerDetailRequestKey.current === requestKey) {
      return;
    }

    lastBannerDetailRequestKey.current = requestKey;
    getBannerData();
  }, [id, isEditing]);

  return (
    <div>
      {clickImageEx_banner && (
        <ImageEx
          title="배너 - 배너 이미지 예시"
          image={<img src={ImageExBanner} style={{ width: "536px" }} />}
          screen={<img src={ScreenExBanner} style={{ width: "536px" }} />}
          handleClickX={handleClickX}
        />
      )}
      {clickImageEx_detail && (
        <ImageEx
          title="배너 - 상세 이미지 예시"
          image={<img src={ImageExDetail} style={{ width: "536px" }} />}
          screen={<img src={ScreenExDetail} style={{ width: "536px" }} />}
          handleClickX={handleClickX}
        />
      )}
      {clickUpload_banner && (
        <ImageUpload
          title="배너이미지 업로드"
          info="배너이미지 권장 사이즈는 1000x250px 입니다"
          handleClickX={handleClickX}
          pageName="BannerApply"
          imageUpload={(img) => setMainImage(img)}
          previewImg={mainImage}
        />
      )}
      {clickUpload_detail && (
        <ImageUpload
          title="상세이미지 업로드"
          info="상세이미지 권장 사이즈는 1000x길이자유px 입니다"
          handleClickX={handleClickX}
          pageName="BannerApply"
          imageUpload={(img) => setSubImage(img)}
          previewImg={subImage}
        />
      )}
      {clickApply && (
        <AlarmApply
          title={
            isEditing ? "배너를 수정하시겠습니까?" : "배너를 등록하시겠습니까?"
          }
          subtitle="등록 시 랭킹마라톤 앱에 데이터가 반영됩니다."
          handleApply={handleApplyBanner}
          handleClickX={handleClickX}
        />
      )}
      {clickCancel && (
        <AlarmCancel
          title="작성하던 내용을 취소하시겠습니까?"
          subtitle="작성하던 내용은 저장되지 않습니다."
          handleCancel={() => navigate("/banner")}
          handleClickX={handleClickX}
        />
      )}
      {inputCheckFail && <AlarmInputCheck handleClickX={handleClickX} />}
      <BannerApplyBox>
        <div className="title-in-box">배너 {isEditing ? "수정" : "등록"}</div>
        <div className="hrz-wrapper">
          <div
            className="text-for-notice"
            style={{ marginLeft: "auto", marginTop: "10px" }}
          >
            *표시는 필수 입력 항목입니다.
          </div>
        </div>

        <AddImage
          title="배너이미지*"
          noticeText="배너이미지 권장 사이즈는 1000x250px 입니다"
          handleClickEx={() => setClickImageEx_banner(true)}
          handleClickUpload={() => setClickUpload_banner(true)}
          previewImg={mainImage}
        />

        <div
          className="hrz-wrapper"
          style={{ marginTop: "40px", marginBottom: "16px" }}
        >
          <p className="subtitle-in-box">옵션 선택</p>
        </div>
        {/* <DateOption
            title="배너 노출 기간*"
            noticeMessage="우리끼리 대회 페이지 최상단에 노출"
          /> */}

        <RadioOption
          title="노출 국가*"
          noticeMessage=""
          option1="국내"
          option2="해외"
          optionChange={(optionNum) => setNation(optionNum)}
          initialOption={nation}
        />

        <AddImage
          title="상세이미지*"
          noticeText="상세이미지 권장 사이즈는 1000x길이자유px 입니다"
          handleClickEx={() => setClickImageEx_detail(true)}
          handleClickUpload={() => setClickUpload_detail(true)}
          previewImg={subImage}
        />

        <div className="hrz-wrapper" style={{ marginTop: "40px" }}>
          <div className="subtitle-in-box">내용 작성</div>
        </div>
        <InputTitle setTitle={setTitle} title={title} />

        <InputContent setContent={setContent} content={content} />

        <div style={{ display: "flex", marginTop: "30px" }}>
          <div
            className="cancelBtn center"
            style={{ marginLeft: "auto" }}
            onClick={() => setClickCancel(true)}
          >
            취소
          </div>
          <div
            className="applyBtn center"
            style={{ marginLeft: "16px" }}
            onClick={() => setClickApply(true)}
          >
            등록
          </div>
        </div>
      </BannerApplyBox>
    </div>
  );
};

const BannerApply = () => {
  return <Layout page={<BannerApplyContent />} />;
};

const BannerApplyBox = styled.div`
  width: auto;
  height: auto;
  border-radius: 20px;
  margin-left: 413px;
  margin-top: 30px;
  margin-bottom: 30px;
  padding: 30px;
  background-color: #ffffff;
`;

export default BannerApply;
